import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { showModal } from 'Views/Components/_HumanWritten/Modal/Base/BaseModalContents';
import { SingleActionModalContent } from 'Views/Components/_HumanWritten/Modal/Base/SingleActionModalContent';
import { Text } from 'Views/Components/Text/Text';

interface RestartWizardModalProps {
	onConfirm?: () => void;
}

export function RestartWizardModalContents({ onConfirm }: RestartWizardModalProps): React.ReactElement {
	return (
		<SingleActionModalContent
			title="Error"
			body={
				<>
					<Text>There has been an error with the reservation process.</Text>
					<Text>Please restart your booking. Sorry for the inconvenience.</Text>
				</>
			}
			confirmContent="Restart"
			onConfirm={onConfirm}
		/>
	);
}

const RestartWizardModalContentsMemo = React.memo(RestartWizardModalContents);

export function showRestartWizardModal(onConfirm: () => void) {
	showModal({
		key: 'restart-booking-wizard',
		content: <RestartWizardModalContentsMemo onConfirm={onConfirm} />,
		modalProps: {
			onRequestClose: onConfirm,
		},
	});
}
